if ( ! document.querySelector('.employee-bookmark-remove')) return;

const employeeRemoveButtons = document.querySelectorAll('.employee-bookmark-remove');
const employeeSaved = document.querySelector('#card--no-saved-jobs');
const confirmRemoveSaved = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
const modal = document.querySelector('.custom-message-modal-overlay');
let employeeSavedCount = parseInt(employeeSaved.getAttribute('data-count'));

if (modal) {
    modal.addEventListener('click', function(e) { 
        if (e.target.classList.contains('removed')) {
            modal.classList.remove('d-flex');
            e.target.remove();
        }
    });
}

employeeRemoveButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        const removePostId = this.getAttribute('data-job');

        confirmRemoveSaved.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        const oldConfirmRemoved = document.querySelector('.custom-message-modal-btn.removed');
        if (oldConfirmRemoved) {
            oldConfirmRemoved.remove();
        }

        confirmRemoveSaved.setAttribute('data-job', removePostId);
        confirmRemoveSaved.setAttribute('data-action', 'remove');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'Are you sure you want to remove job from saved list?';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }
    });
});

confirmRemoveSaved.addEventListener('click', function() {
    const removePostId = this.getAttribute('data-job');
    const clickedRemoveElement = document.querySelector(`.card-list-item-${removePostId}`);
    const modalBody = document.querySelector('.custom-message-modal-body p');

    if (modalBody) {
        modalBody.textContent = 'Removing job from saved list...';
        confirmRemoveSaved.style.display = 'none';
        confirmBtnCancel.style.display = 'none';

        fetch(ajax_callback_data.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'yakkly_employee_bookmark_job',
                postId: removePostId,
                bookmark: 'remove',
                nonce: ajax_callback_data.ajax_nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && clickedRemoveElement) {
                clickedRemoveElement.remove();
                employeeSavedCount--;
                employeeSaved.setAttribute('data-count', employeeSavedCount);
                if (employeeSavedCount < 1) {
                    employeeSaved.classList.remove('hide');
                }
                modalBody.textContent = 'Job removed from saved list';

                const confirmButton = document.createElement('button');
                confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs removed';
                confirmButton.textContent = 'Ok';

                const modalFooter = document.querySelector('.custom-message-modal-footer');
                if (modalFooter) {
                    modalFooter.appendChild(confirmButton);
                }
            } else {
                modalBody.textContent = 'Failed to remove job.';
                console.error('Failed to remove bookmark');
            }
        })
        .catch(err => {
            modalBody.textContent = 'An error occurred.';
            console.error(err);
        });
    }
});